import "./BillingContentComponent.css"
import React, {useRef} from "react";
import {useFlexWrapDetection} from "./FlexWrapDetection";

export default function BillingContentComponent ({children, label, type}) {
    const containerRef = useRef(null);
    const {wrappedIndices} = useFlexWrapDetection(containerRef)

    return (<>
        <div
            ref={containerRef}
            className={`subscriptionInformation-billing-content ${type}${!wrappedIndices.includes(1) ? " withAfter" : ""}`}>
                <span className={"subscriptionInformation-label"}>
                    {label}
                </span>
            <span className={"subscriptionInformation-data"}>
                    {children}
                </span>
        </div>
    </>)
}